module.exports = __webpack_public_path__ + "static/media/2.22503dd6.jpg";